import React from "react";

const NotificationTriggerIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="Group_1411"
        data-name="Group 1411"
        transform="translate(-1233 -262)"
      >
        <g
          id="Ellipse_387"
          data-name="Ellipse 387"
          transform="translate(1233 262)"
          fill="none"
          stroke={fill ? fill : "#000"}
          strokeWidth="2"
        >
          <circle cx="10" cy="10" r="10" stroke="none" />
          <circle cx="10" cy="10" r="9" fill="none" />
        </g>
        <line
          id="Line_371"
          data-name="Line 371"
          y1="4"
          x2="4"
          transform="translate(1243.5 268.5)"
          fill="none"
          stroke={fill ? fill : "#000"}
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default NotificationTriggerIcon;
